import React from 'react'
import { OptionItemInterface } from '../../../../../../common/types/interfaces'
import classes from './StatusSelector.module.sass'

type Props = {
  options: OptionItemInterface[]
  current?: number
  onClick: (value: number) => void
  colorSelector: (value: number) => string
  disabledOptions?: number[]
}

export const StatusSelector = ({
  options,
  current,
  onClick,
  colorSelector,
  disabledOptions = [],
}: Props) => {



  return (
    <div className={classes.container}>
      {options.map((el) => {
        const value = Number(el.value)
        const isDisabled = disabledOptions.includes(value)

        return (
          <div
            onClick={() => !isDisabled && onClick(value)}
            key={el.value}
            className={`
              ${current === value ? classes.itemActive : classes.item}
              ${isDisabled ? classes.disabled : ''}
            `}
            style={{
              backgroundColor: current === value ? colorSelector(value) : '',
              borderColor: current === value ? colorSelector(value) : '',
              opacity: isDisabled ? 0.5 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            {el.label}
          </div>
        )
      })}
    </div>
  )
}
